export {default} from './BookPackageStrongs';
